import React, { useState } from "react";
import ImportExport from "./ImportExport";
import VahanMonthly from "./VahanMonthly";

export default function MacroData() {
  const [activeTab, setActiveTab] = useState("trade");
  const tabs = [
    ["trade", "Import Export"],
    ["vahan", "Vehicle Registrations"],
  ];

  return (
    <main>
      <div className="mx-auto max-w-7xl px-3 pt-3 sm:px-5">
        <div className="inline-flex rounded-xl bg-slate-100 p-1" role="tablist" aria-label="Macro data sections">
          {tabs.map(([key, label]) => (
            <button
              key={key}
              type="button"
              role="tab"
              aria-selected={activeTab === key}
              onClick={() => setActiveTab(key)}
              className={`rounded-lg px-4 py-2 text-sm font-semibold transition ${activeTab === key ? "bg-white text-blue-700 shadow-sm" : "text-slate-500 hover:text-slate-800"}`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      {activeTab === "trade" ? <ImportExport /> : <VahanMonthly />}
    </main>
  );
}
